import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { SupportedLocale } from './types'

export const changeLanguage = async (
    locale: SupportedLocale,
): Promise<void> => {
    await i18n.use(initReactI18next).changeLanguage(locale)
}


